import w3certImage from '../assets/png/Achievements/w3school-certificate.png';

export const achievementData = {
    bio : "Performance-driven full-stack engineer with 7 years’ experience in developing, testing, and rolling-out web applications, with notable specialization in JavaScript, TypeScript, NodeJS and MySQL (as well as AWS, Azure, and other cloud services). Demonstrate adeptness at coordinating large-scale projects, training/managing diverse teams, and resolving emergent technical issues. Leverage seasoned communication skills to transform strategic vision into direct action, as supported by collaborations with associated  teams, stakeholders, and C-level executives. Quickly help startups and enterprises by efficiently converting prototypes and ideas into reality.",
    achievements : [
        {
            id : 1,
            title : 'W3Schools certification',
            details : "W3Schools is the world's largest web developer e-learning site with over 3 billion pages displayed each year and 65 million visitors each month.",
            date : 'June 18, 2017',
            field : 'Typescript',
            image : w3certImage
        },
        // {
        //     id : 2,
        //     title : 'W3Schools certification',
        //     details : "W3Schools is the world's largest web developer e-learning site with over 3 billion pages displayed each year and 65 million visitors each month.",
        //     date : 'Aug 1, 2017',
        //     field : 'React.js',
        //     image : 'https://campus.w3schools.com/cdn/shop/files/18_9628ec14-c7bd-47dd-a0ef-4cab8531644f_113x75_crop_center.png?v=1697543794'
        // },
        {
            id : 3,
            title : 'W3Schools Certification',
            details : "W3Schools is the world's largest web developer e-learning site with over 3 billion pages displayed each year and 65 million visitors each month.",
            date : 'Sep 25, 2018',
            field : 'MySQL',
            image : w3certImage
        },
        {
            id : 4,
            title : 'AWS certification',
            details : 'AWS Certification validates cloud expertise to help professionals highlight in-demand skills and organizations build effective, innovative teams for cloud initiatives using AWS.',
            date : 'Feb 18, 2021',
            field : 'DevOps',
            image : 'https://d1.awsstatic.com/training-and-certification/certification-badges/AWS-Certified-DevOps-Engineer-Professional_badge.7492bf660b5351e51f3f8015e4818924294a7e8c.png'
        },

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/